import axios from 'axios';

export interface CategoryTreeNode {
  _id: string;
  name: string;
  slug: string;
  description?: string;
  image?: string;
  isActive: boolean;
  children: CategoryTreeNode[];
}

export interface CategoryTreeResponse {
  success: boolean;
  count: number;
  data: CategoryTreeNode[];
}

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'https://backend.buildsupplyco.com/api/v1';

class CategoryTreeService {
  private apiUrl: string;
  constructor() {
    this.apiUrl = API_BASE_URL;
  }

  async getCategoryTree(): Promise<CategoryTreeResponse> {
    const response = await axios.get(`${this.apiUrl}/categories/tree`);
    return response.data;
  }
}

const categoryTreeService = new CategoryTreeService();
export default categoryTreeService;
